import React from 'react';
import { Navigate } from 'react-router-dom';
import usePortalAccess from '@/access/usePortalAccess';
import ProtectedRoute from '@/components/ProtectedRoute';
import { useAuth } from '@/contexts/AuthContext';
import {
  getDefaultHomePath,
  isRouteAccessible,
  type PortalRouteDef,
} from '@/config/portalRoutes.config';

type PortalProtectedRouteProps = {
  route: PortalRouteDef;
  children: React.ReactNode;
};

const PortalProtectedRoute = ({
  route,
  children,
}: PortalProtectedRouteProps) => {
  const access = usePortalAccess();
  const { isAuthenticated } = useAuth();

  if (isAuthenticated && !isRouteAccessible(route, access)) {
    return <Navigate to={getDefaultHomePath(access)} replace />;
  }

  return <ProtectedRoute>{children}</ProtectedRoute>;
};

export default PortalProtectedRoute;
